module.exports = __webpack_public_path__ + "img/p35.1b84d2c5.png";